'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*jshint esversion: 6 */

// A class to remove things from the screen
var hide = function () {
	function hide() {
		_classCallCheck(this, hide);
	}

	_createClass(hide, [{
		key: 'dropDowns',
		value: function dropDowns() {
			var open = document.getElementsByClassName('open');
			var openArray = Array.prototype.slice.call(open);

			var faded = document.getElementsByClassName('faded');
			var fadedArray = Array.prototype.slice.call(faded);

			var active = jQuery('.is-active').not('.toolbar-tray');

			openArray.forEach(function (item) {
				item.classList.remove('open');
			});

			fadedArray.forEach(function (item) {
				item.classList.remove('faded');
			});

			jQuery(active).removeClass('is-active');
		}
	}, {
		key: 'fade',
		value: function fade() {
			jQuery('.faded').removeClass('faded');
		}
	}, {
		key: 'booking',
		value: function booking() {
			jQuery('.check-rates').hide();
		}
	}, {
		key: 'mobileMenu',
		value: function mobileMenu() {
			// more efficient than on resize, but...
			// if the CSS changes this will fail
			var menuClasses = [".menu--main", ".menu--secondary-nav"];

			var menus = menuClasses.join(", ");

			if (jQuery(menus).css('z-index') === '7001') {
				jQuery(menus).removeClass('show');
			}
		}
	}, {
		key: 'callUs',
		value: function callUs() {
			var callUsMenu;
			callUsMenu = jQuery('.menu--secondary-nav .sub-menu');
			if (callUsMenu.is(':visible')) {
				callUsMenu.hide();
			}
		}
	}, {
		key: 'all',
		value: function all() {
			this.dropDowns();
			this.booking();
			this.mobileMenu();
		}
	}]);

	return hide;
}();
// Invoke the class so we can use it


var clearScreen = new hide();

jQuery(document).ready(function ($) {
	initHotelRoomGallery();
});

function initHotelRoomGallery() {
	jQuery('a[data-target="#gallery-modal"]').on('click', function () {
		jQuery("#gallery-modal .owl-carousel").owlCarousel({
			items: 1,
			nav: true,
			loop: true
		});
	});
}